/**
 * Chart colors - each legend gets a distinct color
 */
export const chartTheme = {
  brand: "#229a3e",
  brandLight: "rgba(34, 154, 62, 0.35)",
  teal: "#0d9488",
  tealLight: "rgba(13, 148, 136, 0.35)",
  indigo: "#4f46e5",
  indigoLight: "rgba(79, 70, 229, 0.35)",
  violet: "#7c3aed",
  violetLight: "rgba(124, 58, 237, 0.35)",
  amber: "#d97706",
  amberLight: "rgba(217, 119, 6, 0.35)",
  rose: "#e11d48",
  roseLight: "rgba(225, 29, 72, 0.35)",
  slate: "#475569",
  slateLight: "rgba(71, 85, 105, 0.35)",
  sky: "#0284c7",
  skyLight: "rgba(2, 132, 199, 0.35)",
} as const;

/** Status-specific colors - each state has a unique color */
export const statusColors = {
  issued: { bg: chartTheme.brandLight, border: chartTheme.brand },
  activated: { bg: chartTheme.tealLight, border: chartTheme.teal },
  used: { bg: chartTheme.indigoLight, border: chartTheme.indigo },
  exhausted: { bg: chartTheme.violetLight, border: chartTheme.violet },
  expired: { bg: chartTheme.amberLight, border: chartTheme.amber },
  failed: { bg: chartTheme.roseLight, border: chartTheme.rose },
  revoked: { bg: chartTheme.slateLight, border: chartTheme.slate },
} as const;
